(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Card", [], factory);
	else if(typeof exports === 'object')
		exports["Card"] = factory();
	else
		root["Card"] = factory();
})(this, function() {
return 